// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================
   GLOBAL THEME — ADVANCED MODERN ADMIN DASHBOARD
========================================================== */

/* ---------------------------
   Color & Theme System (HSL)
---------------------------- */
:root {
  /* Hues */
  --hue-primary: 211; /* Blue */
  --hue-success: 145; /* Green */
  --hue-danger: 350;  /* Red */
  --hue-warning: 38;  /* Yellow */
  --hue-neutral: 220; /* Grey-Blue */
  --hue-shadow: 220;

  /* Base Colors */
  --font-primary: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Arial, sans-serif;
  --color-bg: hsl(var(--hue-neutral) 25% 97%);
  --color-surface: hsl(0 0% 100%);
  --color-border: hsl(var(--hue-neutral) 20% 90%);
  --color-border-strong: hsl(var(--hue-neutral) 20% 85%);

  /* Typography */
  --color-heading: hsl(var(--hue-neutral) 25% 20%);
  --color-text: hsl(var(--hue-neutral) 20% 30%);
  --color-muted: hsl(var(--hue-neutral) 15% 55%);

  /* Theme Colors */
  --color-primary: hsl(var(--hue-primary) 95% 53%); /* #0d6efd */
  --color-success: hsl(var(--hue-success) 70% 35%); /* #198754 */
  --color-danger: hsl(var(--hue-danger) 80% 50%);  /* #dc3545 */

  /* Sizing & Transitions */
  --radius-sm: 0.5rem;
  --radius-md: 0.75rem;
  --radius-lg: 1rem;
  --ease-out: cubic-bezier(0.25, 0.8, 0.25, 1);
  --transition: all 0.25s var(--ease-out);

  /* Advanced Layered Shadows */
  --shadow-sm: 0 1px 2px hsla(var(--hue-shadow) 30% 30% / 0.04);
  --shadow-md: 0 3px 8px hsla(var(--hue-shadow) 30% 30% / 0.06),
    0 1px 3px hsla(var(--hue-shadow) 30% 30% / 0.05);
  --shadow-lg: 0 10px 25px hsla(var(--hue-shadow) 30% 30% / 0.08),
    0 5px 10px hsla(var(--hue-shadow) 30% 30% / 0.05);
}

/* ---------------------------
   Typography & Base
---------------------------- */
body {
  font-family: var(--font-primary);
  background-color: var(--color-bg);
  color: var(--color-text);
  font-size: 15px;
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}

/* Headings */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 600;
  color: var(--color-heading);
  letter-spacing: -0.01em;
}

/* ---------------------------
   Icon Sizes
---------------------------- */
.h-6 {
  height: 1.5rem;
}
.w-6 {
  width: 1.5rem;
}

/* ==========================================================
   CARDS (StatCard, MainStatCard)
========================================================== */

.card {
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  background-color: var(--color-surface);
  box-shadow: var(--shadow-sm);
  transition: var(--transition);
}

/* Hover Elevation */
.card.cursor-pointer:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-lg);
}

/* Selected State */
.card.border-primary {
  border-color: var(--color-primary) !important;
  box-shadow: 0 0 0 3px hsl(var(--hue-primary) 95% 53% / 0.2);
  background: hsl(var(--hue-primary) 100% 98%);
}

/* Advanced Subtle color variants */
.bg-success-subtle {
  background-color: hsl(var(--hue-success) 90% 96%) !important;
  color: hsl(var(--hue-success) 70% 30%) !important;
}
.bg-danger-subtle {
  background-color: hsl(var(--hue-danger) 90% 97%) !important;
  color: hsl(var(--hue-danger) 80% 45%) !important;
}
.bg-primary-subtle {
  background-color: hsl(var(--hue-primary) 100% 97%) !important;
  color: hsl(var(--hue-primary) 90% 50%) !important;
}

/* Icon Wrappers */
.bg-success-subtle .text-success,
.bg-danger-subtle .text-danger,
.bg-primary-subtle .text-primary {
  color: inherit !important;
}

/* ==========================================================
   TABLES (PaymentsTable & RefundsTable)
========================================================== */

.table {
  font-size: 0.92rem;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}

.table thead.table-light th {
  background-color: var(--color-surface);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 0.8rem;
  color: var(--color-muted);
  padding: 12px 16px;
  border-bottom: 2px solid var(--color-border-strong);
  /* Advanced: Sticky Header */
  position: sticky;
  top: 0;
  z-index: 10;
}

/* Row Styling */
.table tbody tr {
  border-bottom: 1px solid var(--color-border);
}
.table tbody tr:last-child {
  border-bottom: none;
}
.table tbody td {
  padding: 14px 16px;
  border-top: none; /* Replaced by tr border-bottom */
  vertical-align: middle;
}

/* Hover state */
.table-hover > tbody > tr:hover {
  background-color: hsl(var(--hue-primary) 100% 98%);
  transition: background-color 0.2s ease;
}

/* Amount colors */
.text-success {
  color: var(--color-success) !important;
  font-weight: 600;
}
.text-danger {
  color: var(--color-danger) !important;
  font-weight: 600;
}

/* Muted text */
.table .text-muted {
  color: var(--color-muted) !important;
}

/* Rounded table container */
.table-responsive {
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--color-border);
  overflow: hidden;
}

/* ==========================================================
   DETAIL BOX & EMPTY STATE
========================================================== */

.border-dashed {
  border: 2px dashed var(--color-border);
  border-radius: var(--radius-md);
  background-color: hsl(var(--hue-neutral) 20% 98%);
}

.text-center .text-muted {
  font-size: 1rem;
  color: var(--color-muted);
}

/* Empty placeholder */
.border-dashed p {
  margin: 0;
  font-size: 0.95rem;
}

/* ==========================================================
   MODALS (Glassmorphism)
========================================================== */

.modal-content {
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  border: 1px solid hsla(0, 0%, 100%, 0.3);

  /* Advanced: Glass Effect */
  background-color: hsla(0, 0%, 100%, 0.75);
  backdrop-filter: blur(16px) saturate(150%);
  -webkit-backdrop-filter: blur(16px) saturate(150%);
}

.modal-header {
  /* Translucent header */
  background-color: hsla(0, 0%, 100%, 0.5);
  border-bottom: 1px solid var(--color-border);
  border-top-left-radius: var(--radius-lg);
  border-top-right-radius: var(--radius-lg);
}

.modal-header .modal-title {
  font-weight: 600;
  color: var(--color-heading);
}

.modal-footer {
  /* Translucent footer */
  background-color: hsla(0, 0%, 100%, 0.5);
  border-top: 1px solid var(--color-border);
  border-bottom-left-radius: var(--radius-lg);
  border-bottom-right-radius: var(--radius-lg);
}

/* Summary cards inside modals */
.modal-body .bg-light {
  background-color: hsl(var(--hue-neutral) 20% 96%) !important;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--color-border);
  padding: 1rem;
}

/* Buttons */
.btn {
  border-radius: var(--radius-sm);
  font-weight: 500;
  transition: var(--transition);
  box-shadow: var(--shadow-sm);
}
.btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}
.btn:active {
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

/* ==========================================================
   ANIMATIONS
========================================================== */

/* More dynamic fade-in */
.fade-in {
  animation: fadeIn 0.4s var(--ease-out) backwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/CashierDashboardStatistics.css"],"names":[],"mappings":"AAAA;;4DAE4D;;AAE5D;;8BAE8B;AAC9B;EACE,SAAS;EACT,kBAAkB,EAAE,SAAS;EAC7B,kBAAkB,EAAE,UAAU;EAC9B,iBAAiB,GAAG,QAAQ;EAC5B,iBAAiB,GAAG,WAAW;EAC/B,kBAAkB,EAAE,cAAc;EAClC,iBAAiB;;EAEjB,gBAAgB;EAChB;+CAC6C;EAC7C,2CAA2C;EAC3C,+BAA+B;EAC/B,+CAA+C;EAC/C,sDAAsD;;EAEtD,eAAe;EACf,gDAAgD;EAChD,6CAA6C;EAC7C,8CAA8C;;EAE9C,iBAAiB;EACjB,gDAAgD,EAAE,YAAY;EAC9D,gDAAgD,EAAE,YAAY;EAC9D,8CAA8C,GAAG,YAAY;;EAE7D,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,4CAA4C;EAC5C,uCAAuC;;EAEvC,6BAA6B;EAC7B,6DAA6D;EAC7D;oDACkD;EAClD;qDACmD;AACrD;;AAEA;;8BAE8B;AAC9B;EACE,gCAAgC;EAChC,iCAAiC;EACjC,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,aAAa;AACb;;;;;;EAME,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;;8BAE8B;AAC9B;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;;4DAE4D;;AAE5D;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,sCAAsC;EACtC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,6CAA6C;EAC7C,2DAA2D;EAC3D,4CAA4C;AAC9C;;AAEA,mCAAmC;AACnC;EACE,4DAA4D;EAC5D,iDAAiD;AACnD;AACA;EACE,2DAA2D;EAC3D,gDAAgD;AAClD;AACA;EACE,6DAA6D;EAC7D,iDAAiD;AACnD;;AAEA,kBAAkB;AAClB;;;EAGE,yBAAyB;AAC3B;;AAEA;;4DAE4D;;AAE5D;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mDAAmD;EACnD,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB,EAAE,iCAAiC;EACnD,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,kDAAkD;EAClD,sCAAsC;AACxC;;AAEA,kBAAkB;AAClB;EACE,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,oCAAoC;AACtC;;AAEA,4BAA4B;AAC5B;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;;4DAE4D;;AAE5D;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;;4DAE4D;;AAE5D;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,wCAAwC;;EAExC,2BAA2B;EAC3B,yCAAyC;EACzC,0CAA0C;EAC1C,kDAAkD;AACpD;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,4CAA4C;EAC5C,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,yCAAyC;EACzC,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA,gCAAgC;AAChC;EACE,4DAA4D;EAC5D,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;4DAE4D;;AAE5D,yBAAyB;AACzB;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF","sourcesContent":["/* ==========================================================\r\n   GLOBAL THEME — ADVANCED MODERN ADMIN DASHBOARD\r\n========================================================== */\r\n\r\n/* ---------------------------\r\n   Color & Theme System (HSL)\r\n---------------------------- */\r\n:root {\r\n  /* Hues */\r\n  --hue-primary: 211; /* Blue */\r\n  --hue-success: 145; /* Green */\r\n  --hue-danger: 350;  /* Red */\r\n  --hue-warning: 38;  /* Yellow */\r\n  --hue-neutral: 220; /* Grey-Blue */\r\n  --hue-shadow: 220;\r\n\r\n  /* Base Colors */\r\n  --font-primary: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI',\r\n    Roboto, 'Helvetica Neue', Arial, sans-serif;\r\n  --color-bg: hsl(var(--hue-neutral) 25% 97%);\r\n  --color-surface: hsl(0 0% 100%);\r\n  --color-border: hsl(var(--hue-neutral) 20% 90%);\r\n  --color-border-strong: hsl(var(--hue-neutral) 20% 85%);\r\n\r\n  /* Typography */\r\n  --color-heading: hsl(var(--hue-neutral) 25% 20%);\r\n  --color-text: hsl(var(--hue-neutral) 20% 30%);\r\n  --color-muted: hsl(var(--hue-neutral) 15% 55%);\r\n\r\n  /* Theme Colors */\r\n  --color-primary: hsl(var(--hue-primary) 95% 53%); /* #0d6efd */\r\n  --color-success: hsl(var(--hue-success) 70% 35%); /* #198754 */\r\n  --color-danger: hsl(var(--hue-danger) 80% 50%);  /* #dc3545 */\r\n\r\n  /* Sizing & Transitions */\r\n  --radius-sm: 0.5rem;\r\n  --radius-md: 0.75rem;\r\n  --radius-lg: 1rem;\r\n  --ease-out: cubic-bezier(0.25, 0.8, 0.25, 1);\r\n  --transition: all 0.25s var(--ease-out);\r\n\r\n  /* Advanced Layered Shadows */\r\n  --shadow-sm: 0 1px 2px hsla(var(--hue-shadow) 30% 30% / 0.04);\r\n  --shadow-md: 0 3px 8px hsla(var(--hue-shadow) 30% 30% / 0.06),\r\n    0 1px 3px hsla(var(--hue-shadow) 30% 30% / 0.05);\r\n  --shadow-lg: 0 10px 25px hsla(var(--hue-shadow) 30% 30% / 0.08),\r\n    0 5px 10px hsla(var(--hue-shadow) 30% 30% / 0.05);\r\n}\r\n\r\n/* ---------------------------\r\n   Typography & Base\r\n---------------------------- */\r\nbody {\r\n  font-family: var(--font-primary);\r\n  background-color: var(--color-bg);\r\n  color: var(--color-text);\r\n  font-size: 15px;\r\n  line-height: 1.6;\r\n  -webkit-font-smoothing: antialiased;\r\n  text-rendering: optimizeLegibility;\r\n}\r\n\r\n/* Headings */\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  font-weight: 600;\r\n  color: var(--color-heading);\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n/* ---------------------------\r\n   Icon Sizes\r\n---------------------------- */\r\n.h-6 {\r\n  height: 1.5rem;\r\n}\r\n.w-6 {\r\n  width: 1.5rem;\r\n}\r\n\r\n/* ==========================================================\r\n   CARDS (StatCard, MainStatCard)\r\n========================================================== */\r\n\r\n.card {\r\n  border-radius: var(--radius-md);\r\n  border: 1px solid var(--color-border);\r\n  background-color: var(--color-surface);\r\n  box-shadow: var(--shadow-sm);\r\n  transition: var(--transition);\r\n}\r\n\r\n/* Hover Elevation */\r\n.card.cursor-pointer:hover {\r\n  transform: translateY(-3px);\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n/* Selected State */\r\n.card.border-primary {\r\n  border-color: var(--color-primary) !important;\r\n  box-shadow: 0 0 0 3px hsl(var(--hue-primary) 95% 53% / 0.2);\r\n  background: hsl(var(--hue-primary) 100% 98%);\r\n}\r\n\r\n/* Advanced Subtle color variants */\r\n.bg-success-subtle {\r\n  background-color: hsl(var(--hue-success) 90% 96%) !important;\r\n  color: hsl(var(--hue-success) 70% 30%) !important;\r\n}\r\n.bg-danger-subtle {\r\n  background-color: hsl(var(--hue-danger) 90% 97%) !important;\r\n  color: hsl(var(--hue-danger) 80% 45%) !important;\r\n}\r\n.bg-primary-subtle {\r\n  background-color: hsl(var(--hue-primary) 100% 97%) !important;\r\n  color: hsl(var(--hue-primary) 90% 50%) !important;\r\n}\r\n\r\n/* Icon Wrappers */\r\n.bg-success-subtle .text-success,\r\n.bg-danger-subtle .text-danger,\r\n.bg-primary-subtle .text-primary {\r\n  color: inherit !important;\r\n}\r\n\r\n/* ==========================================================\r\n   TABLES (PaymentsTable & RefundsTable)\r\n========================================================== */\r\n\r\n.table {\r\n  font-size: 0.92rem;\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n  width: 100%;\r\n}\r\n\r\n.table thead.table-light th {\r\n  background-color: var(--color-surface);\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  font-size: 0.8rem;\r\n  color: var(--color-muted);\r\n  padding: 12px 16px;\r\n  border-bottom: 2px solid var(--color-border-strong);\r\n  /* Advanced: Sticky Header */\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n}\r\n\r\n/* Row Styling */\r\n.table tbody tr {\r\n  border-bottom: 1px solid var(--color-border);\r\n}\r\n.table tbody tr:last-child {\r\n  border-bottom: none;\r\n}\r\n.table tbody td {\r\n  padding: 14px 16px;\r\n  border-top: none; /* Replaced by tr border-bottom */\r\n  vertical-align: middle;\r\n}\r\n\r\n/* Hover state */\r\n.table-hover > tbody > tr:hover {\r\n  background-color: hsl(var(--hue-primary) 100% 98%);\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n/* Amount colors */\r\n.text-success {\r\n  color: var(--color-success) !important;\r\n  font-weight: 600;\r\n}\r\n.text-danger {\r\n  color: var(--color-danger) !important;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Muted text */\r\n.table .text-muted {\r\n  color: var(--color-muted) !important;\r\n}\r\n\r\n/* Rounded table container */\r\n.table-responsive {\r\n  background: var(--color-surface);\r\n  border-radius: var(--radius-lg);\r\n  box-shadow: var(--shadow-md);\r\n  border: 1px solid var(--color-border);\r\n  overflow: hidden;\r\n}\r\n\r\n/* ==========================================================\r\n   DETAIL BOX & EMPTY STATE\r\n========================================================== */\r\n\r\n.border-dashed {\r\n  border: 2px dashed var(--color-border);\r\n  border-radius: var(--radius-md);\r\n  background-color: hsl(var(--hue-neutral) 20% 98%);\r\n}\r\n\r\n.text-center .text-muted {\r\n  font-size: 1rem;\r\n  color: var(--color-muted);\r\n}\r\n\r\n/* Empty placeholder */\r\n.border-dashed p {\r\n  margin: 0;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n/* ==========================================================\r\n   MODALS (Glassmorphism)\r\n========================================================== */\r\n\r\n.modal-content {\r\n  border-radius: var(--radius-lg);\r\n  box-shadow: var(--shadow-lg);\r\n  border: 1px solid hsla(0, 0%, 100%, 0.3);\r\n\r\n  /* Advanced: Glass Effect */\r\n  background-color: hsla(0, 0%, 100%, 0.75);\r\n  backdrop-filter: blur(16px) saturate(150%);\r\n  -webkit-backdrop-filter: blur(16px) saturate(150%);\r\n}\r\n\r\n.modal-header {\r\n  /* Translucent header */\r\n  background-color: hsla(0, 0%, 100%, 0.5);\r\n  border-bottom: 1px solid var(--color-border);\r\n  border-top-left-radius: var(--radius-lg);\r\n  border-top-right-radius: var(--radius-lg);\r\n}\r\n\r\n.modal-header .modal-title {\r\n  font-weight: 600;\r\n  color: var(--color-heading);\r\n}\r\n\r\n.modal-footer {\r\n  /* Translucent footer */\r\n  background-color: hsla(0, 0%, 100%, 0.5);\r\n  border-top: 1px solid var(--color-border);\r\n  border-bottom-left-radius: var(--radius-lg);\r\n  border-bottom-right-radius: var(--radius-lg);\r\n}\r\n\r\n/* Summary cards inside modals */\r\n.modal-body .bg-light {\r\n  background-color: hsl(var(--hue-neutral) 20% 96%) !important;\r\n  border-radius: var(--radius-md);\r\n  box-shadow: var(--shadow-sm);\r\n  border: 1px solid var(--color-border);\r\n  padding: 1rem;\r\n}\r\n\r\n/* Buttons */\r\n.btn {\r\n  border-radius: var(--radius-sm);\r\n  font-weight: 500;\r\n  transition: var(--transition);\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n.btn:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n.btn:active {\r\n  transform: translateY(-1px);\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n/* ==========================================================\r\n   ANIMATIONS\r\n========================================================== */\r\n\r\n/* More dynamic fade-in */\r\n.fade-in {\r\n  animation: fadeIn 0.4s var(--ease-out) backwards;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px) scale(0.98);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
